import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";
import { makeStyles } from "@material-ui/core/styles";
import { hasAccess } from "actions";

class SidenavContent extends Component {
  componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`; // get current path

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        const parentLiEle = that.closest(this, "li");
        if (menuLi[i].classList.contains("menu") && parentLiEle !== null) {
          event.stopPropagation();

          if (menuLi[i].classList.contains("open")) {
            menuLi[i].classList.remove("open", "active");
          } else {
            menuLi[i].classList.add("open", "active");
          }
        } else {
          for (let j = 0; j < menuLi.length; j++) {
            const parentLi = that.closest(this, "li");
            if (
              menuLi[j] !== this &&
              (parentLi === null || !parentLi.classList.contains("open"))
            ) {
              menuLi[j].classList.remove("open");
            } else {
              if (menuLi[j].classList.contains("open")) {
                menuLi[j].classList.remove("open");
              } else {
                menuLi[j].classList.add("open");
              }
            }
          }
        }
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`; // get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function (fn) {
        if (typeof document.body[fn] === "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {}

    return null;
  }

  render() {
    let hideAdministration =
      sessionStorage.getItem("user") &&
      (JSON.parse(sessionStorage.getItem("user")).ROLE_ID == 6 ||
        JSON.parse(sessionStorage.getItem("user")).ROLE_ID == 1)
        ? false
        : true;
    let hideConsignment =
      sessionStorage.getItem("user") &&
      (JSON.parse(sessionStorage.getItem("user")).ROLE_ID == 2 ||
        JSON.parse(sessionStorage.getItem("user")).ROLE_ID == 3 ||
        JSON.parse(sessionStorage.getItem("user")).ROLE_ID == 1)
        ? false
        : true;
    let unHideDashboard = hasAccess("dashboard");
    let unHideIntents = hasAccess("intents/list");

    let hideIntent =
      sessionStorage.getItem("user") &&
      (JSON.parse(sessionStorage.getItem("user")).ROLE_ID == 4 ||
        JSON.parse(sessionStorage.getItem("user")).ROLE_ID == 5 ||
        JSON.parse(sessionStorage.getItem("user")).ROLE_ID == 1)
        ? false
        : true;

    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">
          <li className="nav-header">
            <IntlMessages id="sidebar.main" />
          </li>
          {/* hidden={(hasAccess('dashboard'))?true:false} */}
          <li
            className="menu no-arrow"
            hidden={
              hasAccess("dashboard", "dashboard").dashboard == true
                ? false
                : true
            }
          >
            <NavLink to="/app/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="pages.dashboard" />{" "}
              </span>
            </NavLink>
            <NavLink className="prepend-icon" to="/app/fingerprintregistration">
            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="pages.administartionUsers.registerFinger" />
              </span>
            </NavLink>
            <NavLink className="prepend-icon" to="/app/verifyfinger">
            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="pages.administartionUsers.verifyFinger" />
              </span>
            </NavLink>
          </li>
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(SidenavContent);
